import React, { useState, useEffect, useRef } from "react";
import "./MiddleBar.css";
import logo from "../../dextra-logo.jpeg";
// import heart from '../assets/Heart.svg';
// import cart from '../assets/Cart.png';
import phone from "../Assets/PhoneCall.png";
import searchIcon from "../../assets/Search.svg"; // Import your search icon
// import ShoppingCard from '../Page/popupcard';
import { useNavigate } from "react-router-dom";
import { getWithoutTokenAPI } from "../../util/Api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MiddleBar = () => {
  //   const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const searchRef = useRef(null);
  const phoneNumber = '+91 4448648848'; 
  const [showError, setShowError] = useState(false);

  const handleClick = () => {
    setShowError(false);

    window.location.href = `tel:${phoneNumber}`;

    setTimeout(() => {
      setShowError(true);
    }, 3000);
  };
  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        const response = await getWithoutTokenAPI('/product/find-all');
        if (response?.statusCode === 200 && response.data?.Product) {
          setAllProducts(response.data.Product);
        }
      } catch (error) {
        console.error("Error fetching all products:", error);
      }
    };
    fetchAllProducts();
  }, []);

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Filter products based on search text
  useEffect(() => {
    if (searchText.trim().length < 2) {
      setSuggestions([]);
      return;
    }

    const searchTerm = searchText.toLowerCase();
    const filteredProducts = allProducts.filter(product =>
      product.name.toLowerCase().includes(searchTerm) ||
      product.tag?.some(tag => tag.toLowerCase().includes(searchTerm)) ||
      product.category_id?.category_name.toLowerCase().includes(searchTerm)
    );

    setSuggestions(filteredProducts.slice(0, 10));
    setShowSuggestions(true);
  }, [searchText, allProducts]);

  const handleSearch = async () => {
    if (!searchText.trim()) {
      toast.warning("Please enter a search term");
      return;
    }

    setIsSearching(true);
    try {
      const searchTerm = searchText.toLowerCase();
      const filteredProducts = allProducts.filter(product =>
        product.name.toLowerCase().includes(searchTerm) ||
        product.tag?.some(tag => tag.toLowerCase().includes(searchTerm)) ||
        product.category_id?.category_name.toLowerCase().includes(searchTerm)
      );

      navigate('/search-results', {
        state: {
          searchResults: filteredProducts,
          searchTerm: searchText
        }
      });
    } catch (error) {
      toast.error(error.message || "An error occurred while searching");
    } finally {
      setIsSearching(false);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (product) => {
    setSearchText(product.name);
    setShowSuggestions(false);
    navigate(`/product?_id=${product._id}&product_name=${product.name}&seller_name=${product.seller_id.name}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = '/placeholder.png';
  };

  return (

    <div className="middles container-fluid">
      <ToastContainer autoClose={3000} />

      <div className="row align-items-center justify-content-between ">
        {/* Logo Column - col-md-3 means 3/12 width on medium+ screens, full width on mobile */}
        <div className="col-12 col-md-3  mb-md-0 text-sm-start text-md-start ">
          <img
            src={logo}
            alt="company_logo"
            class="nav-logo-con"
            onClick={() => navigate('/')}
            // style={{ cursor: 'pointer', maxHeight: '60px' }}
            style={{ cursor: 'pointer' }}
          />
        </div>

        {/* Search Column - col-md-6 means 6/12 width on medium+ screens */}
        <div className="col-12 col-md-6 mb-md-0 position-relative d-none d-md-block " ref={searchRef}>
          <div className="input-group input-position mb-0">
            <span className="input-group-text bg-white border-end-0">
              <img src={searchIcon} alt="search" className="search-icon" style={{ height: '20px' }} />
            </span>
            {/* <input
          className="form-control border-start-0 py-2 "
          placeholder="Search by product name"
          type="text"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyPress={handleKeyPress}
          onFocus={() => searchText.length >= 2 && setShowSuggestions(true)}
        /> */}
            <input
              className="form-control border-start-0 py-2 no-focus-outline"
              style={{ outline: 'none', boxShadow: 'none' }}  // 👈 ADD THIS
              placeholder="Search Product"
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyPress={handleKeyPress}
              onFocus={() => searchText.length >= 2 && setShowSuggestions(true)}
            />

          </div>

          {showSuggestions && suggestions.length > 0 && (
            <div className="suggestions-dropdown position-absolute w-100 bg-white mt-1 shadow rounded" style={{ zIndex: 1000 }}>
              {suggestions.map((product) => (
                <div
                  key={product._id}
                  className="suggestion-item p-2 d-flex align-items-center border-bottom"
                  onClick={() => handleSuggestionClick(product)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="suggestion-image-container me-3" style={{ width: '50px', height: '50px' }}>
                    <img
                      src={product.product_image[0]}
                      alt={product.name}
                      className="suggestion-image img-fluid h-100 w-100 object-fit-cover"
                      onError={handleImageError}
                    />
                  </div>
                  <div className="suggestion-details">
                    <span className="suggestion-name d-block fw-bold">{product.name}</span>
                    <div className="suggestion-meta d-flex gap-2">
                      <span className="suggestion-category text-muted small">{product.category_id?.category_name}</span>
                      {/* {product.tag && product.tag.length > 0 && (
                    <span className="suggestion-tag badge bg-secondary small">{product.tag[0]}</span>
                  )} */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      <div className="col-12 col-md-3 phone-hidden">
  <div className="phone-container d-flex align-items-center justify-content-end">
    <div className="support-call-wrapper">
      <button
        className="btn callbutton"
        style={{ backgroundColor: "#CC0000", color: "white" }}
      >
        Schedule a Support Call
      </button>
      <div className="hover-phone-number">
        Call Us: <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
      </div>
    </div>
  </div>
</div>

      </div>
    </div>
  );
};

export default MiddleBar;
